var TabApprovalsEquipmentsModule = /** @class */ (function () {
    function TabApprovalsEquipmentsModule() {
    }
    return TabApprovalsEquipmentsModule;
}());
export { TabApprovalsEquipmentsModule };
